import { createSlice } from '@reduxjs/toolkit';
import { createFilterInitialState, filterReducers } from 'common/utils/sliceUtils/filterSliceUtils';

import type { RootState } from '../../app/store';

const userGroupUserMembershipSlice = createSlice({
    name: 'userGroupUserMembership',
    initialState: createFilterInitialState(),
    reducers: () => ({
        ...filterReducers,
    })
});

// eslint-disable-next-line no-restricted-syntax
export default userGroupUserMembershipSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters } = userGroupUserMembershipSlice.actions;
export const selectFilters = (state: RootState) => state.userGroupUserMembership.filters;
